import { t } from '@/i18n';
import z from 'zod';

// 指標タイプ
export const indicatorTypeEnum = z.enum(['activity', 'output', 'outcome']);

export const IndicatorTypeModifier = {
  activity: t('activity'),
  output: t('output'),
  outcome: t('outcome'),
} as const satisfies Record<z.infer<typeof indicatorTypeEnum>, string>;

// 期間
export const indicatorTermEnum = z.enum(['short', 'medium', 'long']);

export const IndicatorTermModifier = {
  short: t('short-term'),
  medium: t('medium-term'),
  long: t('long-term'),
} as const satisfies Record<z.infer<typeof indicatorTermEnum>, string>;

// データ性質
export const indicatorDataNatureTypeEnum = z.enum([
  'qualitative',
  'quantitative',
]);

export const IndicatorDataNatureTypeModifier = {
  qualitative: t('qualitative'),
  quantitative: t('quantitative'),
} as const satisfies Record<
  z.infer<typeof indicatorDataNatureTypeEnum>,
  string
>;
